import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import ContentSuggestion from "../../../../ContentSuggestion/ContentSuggestion/ContentSuggestion.js";
import SuggestionBlock from "../../../../SuggestionBlock/SuggestionBlock/SuggestionBlock.js";
function ContentResultsContainer({
  suggestions,
  handleClickAnalytics,
  handleSubmit
}) {
  const { getLabel } = useIntl();
  const filteredSuggestions = suggestions.hits.filter((suggestion) => suggestion.title && suggestion.link).slice(0, 4);
  return /* @__PURE__ */ React.createElement(
    SuggestionBlock,
    {
      title: getLabel("search.suggestions.content.title"),
      handleSubmit: () => handleSubmit("content"),
      suggestions: filteredSuggestions,
      render: (hit) => /* @__PURE__ */ React.createElement(
        ContentSuggestion,
        {
          key: hit.objectID,
          suggestion: hit,
          onClick: handleClickAnalytics(suggestions.index)
        }
      )
    }
  );
}
export {
  ContentResultsContainer as default
};
//# sourceMappingURL=ContentSuggestionContainer.js.map
